import { render } from "./BaseReportHandler.vue?vue&type=template&id=464f45b2&scoped=true&ts=true"
import script from "./BaseReportHandler.vue?vue&type=script&lang=ts"
export * from "./BaseReportHandler.vue?vue&type=script&lang=ts"

import "./BaseReportHandler.vue?vue&type=style&index=0&id=464f45b2&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-464f45b2"]])

export default __exports__